const $ = jQuery.noConflict();
import 'slick-carousel';

import {gsap} from 'gsap';
import {TextPlugin} from 'gsap/TextPlugin';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {SplitText} from 'gsap/SplitText';
import Fancybox from './fancybox';

gsap.registerPlugin(TextPlugin, ScrollTrigger, SplitText);

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$domSliderAlt: $('.js-slider-alt'),
	$domSliderArrowLeft: $('.js-slider__wrap-arrow-left'),
	$domSliderArrowRight: $('.js-slider__wrap-arrow-right'),
	$domSliderArrowLeftAlt: $('.js-slider__wrap-arrow-left-alt'),
	$domSliderArrowRightAlt: $('.js-slider__wrap-arrow-right-alt'),
	$domSliderTestimonials: $('.js-testimonials-box'),
	$domSliderTestimonialsArrowLeft: $('.js-testimonials-box__wrap-arrow-left'),
	$domSliderTestimonialsArrowRight: $('.js-testimonials-box__wrap-arrow-right'),
	$domSliderGallery: $('.js-slider-gallery'),
	$domSliderGalleryDetails: $('.js-gallery-detail'),
	$domSliderGalleryArrowLeft: $('.js-gallery-arrow-left'),
	$domSliderGalleryArrowRight: $('.js-gallery-arrow-right'),


	/** @description Initialize. */
	init: function() {
		this.initLogoSlider();
		this.initLogoAltSlider();
		this.initSliderTestimonials();
		this.initSliderGallery();
		this.initGalleryDetail();
		$('.slider-gallery__tabs-link').on('click', function() {
			$('.js-slider-gallery').slick('refresh');
		});

		const hasVideo = $('.slider-gallery__box-wrap');
		if (hasVideo) {
			hasVideo.parent().addClass('has-video');
		}
		const galleryHasVideo = $('.gallery-boxes__box-wrap');
		if (galleryHasVideo) {
			galleryHasVideo.parent().addClass('has-video');
		}

		//Trying to refresh slick when the ajax is fine
		// $('.js-slider-gallery__box').on('click', function() {
		// 	$('.js-loader').addClass('active active-popup');
		// 	$.ajax({
		// 		type: 'POST',
		// 		// eslint-disable-next-line no-undef
		// 		url: LaibelAjax.ajaxUrl,
		// 		data: {
		// 			action: 'GetGallery',
		// 		},
		// 		success: function(response) {
		// 			const galleryDetail = $(response.htmlPosts);
		// 			galleryDetail.addClass('is-active');
		// 			$('.js-gallery-detail').slick('refresh');
		// 			setTimeout(() => {
		// 				$('.js-loader').removeClass('active active-popup');
		// 			}, 3000);
		// 		}
		// 	});
		// });
	},

	/** @description Set and run gallery slider. */
	initLogoSlider: function() {
		$('.js-slider').each(function(i, el) {
			// create object with base config options
			const baseConfig = new SliderBaseConfig();
			// set extra config options
			const extraConfig = {
				infinite: true,
				autoplay: true,
				autoplaySpeed: 500,
				slidesToShow: 5,
				slidesToScroll: 1,
				pauseOnFocus: true,
				pauseOnHover: true,
				arrows: true,
				prevArrow: $(el).parent().find('.js-slider__wrap-arrow-left'),
				nextArrow: $(el).parent().find('.js-slider__wrap-arrow-right'),
				responsive: [
					{
						breakpoint: 1501,
						settings: {
							slidesToShow: 4,
							variableWidth: false,
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 3,
							variableWidth: false,
							autoplaySpeed: 2000,
						}
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 2,
							variableWidth: false,
						}
					},
					{
						breakpoint: 425,
						settings: {
							slidesToShow: 1,
							variableWidth: false,
						}
					}
				]
			};
			// merge two config objects
			const config = {
				...baseConfig,
				...extraConfig
			};
			// run slider
			Sliders.runSlider($(el), config);
		});
	},

	initLogoAltSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			variableWidth: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $('.js-slider__wrap-arrow-left-alt'),
			nextArrow: $('.js-slider__wrap-arrow-right-alt'),
			responsive: [
				{
					breakpoint: 1500,
					settings: {
						slidesToShow: 4,
						variableWidth: false,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 3,
						variableWidth: false,
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 2,
						variableWidth: false,
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderAlt, config);
	},

	initSliderTestimonials: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: true,
			prevArrow: $('.js-testimonials-box__wrap-arrow-left'),
			nextArrow: $('.js-testimonials-box__wrap-arrow-right'),
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			swipeToSlide: false,
			swipe: false,
			draggable: false,
			touchMove: false,
			//swipe had to be removed because of the animation issue. Before/After change is very buggy.
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderTestimonials, config);
	},

	initSliderGallery: function() {
		$('.js-slider-gallery').each(function(i, el) {
			// create object with base config options
			const baseConfig = new SliderBaseConfig();
			// set extra config options
			const extraConfig = {
				infinite: true,
				autoplay: false,
				variableWidth: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				prevArrow: $(el).next().find('.js-gallery-arrow-left-outer'),
				nextArrow: $(el).next().find('.js-gallery-arrow-right-outer'),
				arrows: true,
				responsive: [
					{
						breakpoint: 1700,
						settings: {
							slidesToShow: 2,
							variableWidth: false,
							centerMode: true,
						}
					},
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 3,
							variableWidth: false,
						}
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2,
							variableWidth: false,
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							variableWidth: false,
						}
					}
				]
			};
			// merge two config objects
			const config = {
				...baseConfig,
				...extraConfig
			};
			// run slider
			Sliders.runSlider($(el), config);
		});
	},

	initGalleryDetail: function() {
		const url = window.location.href;
		const hashes = url.split('?')[1];
		let number = 0;
		if (hashes) {
			number = hashes.split('=')[1] - 1;
		}

		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: false,
			autoplay: false,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			centerMode: true,
			pauseOnHover: false,
			prevArrow: $('.js-gallery-arrow-left'),
			nextArrow: $('.js-gallery-arrow-right'),
			// initialSlide: number,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						adaptiveHeight: true,
						slidesToShow: 1,
						variableWidth: false,
					}
				},
			]
		};

		$('.js-gallery-detail__popup-opener').on('click', function(e) {
			if($(this).find('.gallery-detail__popup-box').hasClass('popup-show')) {
				$(this).find('.gallery-detail__popup-box').removeClass('popup-show');
				$(this).parent().removeClass('no-transform');
				$(this).parent().parent().removeClass('no-transform');
				$('.gallery-detail__vid').trigger('pause');
				e.currentTarget.querySelector('.gallery-detail__vid').pause();
				const videos = document.querySelectorAll('iframe');
				videos.forEach(i => {
					const source = i.src;
					i.src = '';
					i.src = source;
				});
			} else {
				e.currentTarget.querySelector('.gallery-detail__vid').play();
				$(this).find('.gallery-detail__popup-box').addClass('popup-show');
				$(this).parent().addClass('no-transform');
				$(this).parent().parent().addClass('no-transform');
				$(this).addClass('video-is-iframe');
			}
		});

		$('.js-gallery-detail__popup-opener').on('mouseenter', function() {
			$('.js-gallery-detail__popup-opener').removeClass('video-enter');
			$(this).addClass('video-enter');
			$(this).find('.js-gallery-detail__popup-cover').trigger('play');
			$('iframe').parent().addClass('is-iframe');
		});

		$('.js-gallery-detail__popup-opener').on('mouseleave', function() {
			if($(this).hasClass('video-enter')) {
				$(this).removeClass('video-enter');
				$(this).find('.js-gallery-detail__popup-cover').trigger('pause');
			}
		});

		$('.gallery-detail__popup-cover').trigger('pause');

		// Autoplay video on current slide and slide counter
		$('.js-gallery-detail').on('setPosition', function(event, slick, currentSlide){
			if($('.slick-slide.slick-current').find('video').length !== 0) {
				$('.js-gallery-detail .slick-current').find('video').get(0).play();
			}
		});
		$('.js-gallery-detail').on('beforeChange', function(event, slick, currentSlide, nextSlide, slide, index){
			$('video').each(function() {
				let videoBlock = $('.js-video-block').get(0);
				if (videoBlock && typeof videoBlock.pause === 'function') {
					videoBlock.pause();
				}
			});
			history.replaceState(null, null, $(slick.$slides.get(nextSlide)).data('link'));
		});
		$('.js-gallery-detail').on('afterChange', function(event, slick, currentSlide) {
			$('.js-gallery-detail__mini-nav-current').text(currentSlide + 1);
			if($('.slick-slide.slick-current').find('video').length !== 0) {
				$('.js-gallery-detail .slick-current').find('video').get(0).play();
			}
		});

		$('.js-gallery-detail').on('init', function(event, slick, currentSlide) {
			const url = window.location.href;
			const hashes = url.split('?')[1];

			if (hashes) {
				const number = hashes.split('=')[1];

				// $('.js-gallery-detail__mini-nav-current').text(number);
				// if($('.slick-slide.slick-current').find('video').length !== 0) {
				// 	$('.js-gallery-detail .slick-current').find('video').get(0).play();
				// }
				if (number > 1) {
					setTimeout(() => {
						$('.js-gallery-detail').slick('slickGoTo', number - 1);
					}, 1300);
					return;
				}
			} else {
				history.replaceState(null, null, $(slick.$slides.get(currentSlide)).data('link'));
			}
		});

		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider

		setTimeout(function() {
			Sliders.runSlider($('.js-gallery-detail'), config);
		}, 400);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
